import type { SnowplowEvent } from 'analytics/snowplow/events'
import { activateCampaignEvent } from 'analytics/snowplow/events'

const CHERTO_CAMPAIGN_ID = 'cherto'

export function getExperimentActivationEvent(
  experimentKey: string,
  experiment: App.AnyExperimentDetails,
): SnowplowEvent | undefined {
  if (experiment.provider === 'cherto') {
    // Cherto exposure is tracked through LE's existing Snowplow activation event,
    // not Cherto's native enrollment ingest.
    return activateCampaignEvent(
      CHERTO_CAMPAIGN_ID,
      experiment.experimentId ?? experimentKey,
      experiment.variationKey,
    )
  }

  if (!experiment.campaignId || !experiment.experimentId) {
    return
  }

  const variationId = experiment.variation?.[experiment.variationKey]
  if (!variationId) {
    return
  }

  return activateCampaignEvent(
    experiment.campaignId,
    experiment.experimentId,
    variationId,
  )
}
